export default function totalCartItems() {
  const cart = JSON.parse(localStorage.checkout);
  let total = 0;
  for (let i = 0; i < cart.length; i++) {
    total = (cart[i].price * cart[i].qt) + total;
  };

  return total.toFixed(2);
};



// WEBPACK FOOTER //
// ./src/components/totalCartItems.js